import { approveAds, deleteAdvertisement, getAds, getAdvertisementTypes, getOfferTypes, rejectAd, updateAdvertisement } from "../../../api/ads";
import View from "../../../assets/icons/view.svg";
import Trash from "../../../assets/icons/trash.svg";
import { useEffect, useState } from "react";
import { message, Pagination, Space, Tag } from "antd";
import moment from "moment";
import Table from "./../../../components/common/table";
import DeleteMemberModal from "../../../components/common/modalMember";
import EditAdvertisementModal from "../../../components/common/editAdvertisementModal";

const AdsApproval = () => {
  const columns = [
    {
      title: "Vendor",
      dataIndex: "orderNumber",
      key: "orderNumber",
      render: (text, record) => `${record.businessId.businessName}`,
    },
    {
      title: "Ad Type",
      key: "advertisementTypeId",
      render: (text, record) =>
        `${record.advertisementTypeId.name} (${record.offerTypeId.name})`,
    },
    {
      title: "Service",
      key: "serviceId",
      dataIndex: ["serviceId", "serviceName"],
    },
    {
      title: "No. of Days",
      key: "numberOfDays",
      dataIndex: "numberOfDays",
    },
    {
      title: "Amount ($)",
      dataIndex: "numberOfDays",
      key: "numberOfDays",
      render: (text) => <>${text * 10}</>,
    },
    {
      title: "Start Date",
      key: "startDate",
      render: (text, record) =>
        `${moment(record.startDate).format("MM/DD/YYYY")}`,
    },
    {
      title: "End Date",
      key: "endDate",
      render: (text, record) =>
        `${moment(record.endDate).format("MM/DD/YYYY")}`,
    },
    {
      title: "Status",
      key: "isApproved",
      render: (status, record) => AdStatusTag(record?.isApproved),
    },
    {
      title: "Actions",
      key: "actions",
      render: (text, record) => (
        <div className="flex space-x-2">
          {record?.isApproved === "PENDING" ? (
            <>
              <Space size="middle">
                <Tag
                  className="cursor-pointer"
                  color="#5530C1"
                  onClick={() => openModal(record?._id, "approve")}
                >
                  Approve
                </Tag>
                <Tag
                  className="cursor-pointer"
                  color="#F62424"
                  onClick={() => openModal(record?._id, "decline")}
                >
                  Decline
                </Tag>
              </Space>
            </>
          ) : (
            <>
              <div className="flex space-x-1">
                <div
                  onClick={() => openEditModal(record)}
                  className="w-4 m-auto grid justify-center h-4 pt-1 rounded-full bg-lightLavender cursor-pointer"
                >
                  <img src={View} alt="View" />
                </div>
                <div
                  onClick={() => openDeleteModal(record?._id)}
                  className="w-4 m-auto grid justify-center h-4 pt-1 rounded-full bg-lightCrimson cursor-pointer"
                >
                  <img src={Trash} alt="Delete" />
                </div>
              </div>
            </>
          )}
        </div>
      ),
    },
  ];

  const itemRender = (page, type, originalElement) => {
    if (type === "page") {
      return (
        <div
          className={`rounded ${
            currentPage === page
              ? "bg-primaryPurple text-white"
              : "bg-white text-black"
          }`}
          style={{ cursor: "pointer" }}
        >
          {page}
        </div>
      );
    }
    return originalElement;
  };

  const AdStatusTag = (status) => {
    return (
      <>
        {status === "APPROVED" ? (
          <Tag color="success">Approved</Tag>
        ) : status === "REJECTED" ? (
          <Tag color="error">Rejected</Tag>
        ) : (
          <Tag color="warning">Pending</Tag>
        )}
      </>
    );
  };

  const [ads, setAds] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPagesize] = useState(10);
  const [loader, setLoader] = useState(false);
  const [adStatus, setAdStatus] = useState(null);
  const [confirmModal, handleConfirmModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [editModal, setEditModal] = useState(false);
  const [currentAd, setCurrentAd] = useState(null);
  const [advertisementTypes, setAdvertisementTypes] = useState([]);
  const [offerTypes, setOfferTypes] = useState([]);

  const fetchData = async () => {
    setLoader(true);
    const res = await getAds(currentPage, pageSize);
    if (res) {
      setAds(res);
    }
    setLoader(false);
  };
  
  const fetchAdvertisementTypes = async () => {
    const res = await getAdvertisementTypes();
    if (res) {
      setAdvertisementTypes(res);
    }
  };
  
  const fetchOfferTypes = async () => {
    const res = await getOfferTypes();
    if (res) {
      setOfferTypes(res);
    }
  };
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSizeChange = (current, size) => {
    setPagesize(size);
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, pageSize]);
  
  useEffect(() => {
    fetchAdvertisementTypes();
    fetchOfferTypes();
  }, []);

  const handleStatusUpdate = async () => {
    const { id, btn } = adStatus;
    debugger;
    if (btn === "approve") {
      const res = await approveAds(id);
      if (res) {
        message.success("Ad approved successfully.");
      }
    } else {
      const res = await rejectAd(id);
      if (res) {
        message.success("Ad declined successfully.");
      }
    }
    fetchData();
  };

  const openModal = (id, btn) => {
    setAdStatus({ id, btn });
    handleConfirmModal(true);
  };

  const handleConfirmYes = () => {
    handleConfirmModal(false);
    handleStatusUpdate();
  };

  const openDeleteModal = (id) => {
    setDeleteId(id);
    setDeleteModal(true);
  };

  const handleDeleteConfirm = async () => {
    try {
      const res = await deleteAdvertisement(deleteId);
      if (res) {
        message.success("Advertisement deleted successfully.");
        fetchData();
      }
    } catch (error) {
      message.error("Failed to delete advertisement.");
    } finally {
      setDeleteModal(false);
      setDeleteId(null);
    }
  };

  const openEditModal = (ad) => {
    setCurrentAd(ad);
    setEditModal(true);
  };

  const handleEditSuccess = () => {
    setEditModal(false);
    setCurrentAd(null);
    fetchData();
  };

  return (
    <>
      <div className="">
        <div className="flex items-center ml-2 mt-2 ">
          <span className="text-lg font-medium text-black ml-1">Ads</span>
        </div>

        <div>
          <div>
            <div className="flex items-start justify-start pt-0">
              <Table
                columns={columns}
                data={ads?.items}
                loading={loader}
              />
            </div>
          </div>
        </div>
        <div className="flex justify-center items-center pagination-container mb-2">
          <Pagination
            current={currentPage}
            total={ads?.totalItems}
            pageSize={pageSize}
            onShowSizeChange={handleSizeChange}
            pageSizeOptions={[10, 20, 30, 40]}
            onChange={(e) => {
              handlePageChange(e);
            }}
            itemRender={itemRender}
            responsive={true}
            className="custom-pagination"
          />
        </div>
      </div>
      {confirmModal && (
        <DeleteMemberModal
          title="Confirm Action"
          text="Are you sure you want to proceed?"
          onCancel={() => handleConfirmModal(false)}
          onOk={handleConfirmYes}
        />
      )}
      {deleteModal && (
        <DeleteMemberModal
          title="Delete Advertisement"
          text="Are you sure you want to delete this advertisement?"
          onCancel={() => setDeleteModal(false)}
          onOk={handleDeleteConfirm}
        />
      )}
      {editModal && currentAd && (
        <EditAdvertisementModal
          onCancel={() => setEditModal(false)}
          advertisement={currentAd}
          advertisementTypes={advertisementTypes}
          offerTypes={offerTypes}
          onSuccess={handleEditSuccess}
        />
      )}
    </>
  );
};
export default AdsApproval;
